import React, { Component } from "react";
import "./CarouselWidget.css";


export default class BlogWidget extends Component {

  constructor(props){
    super(props);
    this.state ={
      images: []
    };
  }

  renderCarousel(images, blogId){
      const listImages = images.map((image, index) =>
        index === 0 ?
                      <div key={index} className="carousel-item active">
                          <img className="d-block w-100" src={"" + image} alt="First slide" />
                      </div>

                    : <div key={index} className="carousel-item ">
                        <img className="d-block w-100" src={"" + image} alt="First slide" />
                    </div>
      );

      return(
        <div id={blogId+"carouselControls"} className="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            {listImages}
          </div>
          <a className="carousel-control-prev" href={"#"+blogId+"carouselControls"}  role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href={"#"+blogId+"carouselControls"} role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      );
  }

  renderImage(imageOrVideo, blog){

      if(imageOrVideo === undefined){
        //when there is no attachment.
        return "";
      }else{

        if(blog.isVideo === "true"){
          return this.renderVideo(imageOrVideo);
        }else{
          return(
                 <div className="block block-image-holder">
                     <div className="block-image">

                         <a href="">
                             <img src={"" + imageOrVideo}
                           className="img-fluid img-center single-image" />
                         </a>
                     </div>
                 </div>
             );
        }

      }

  }

  renderVideo(videoPath){
      if(videoPath === undefined){
        return "";
      }else{
        return(
               <div className="block block-image-holder">
                   <div className="block-image">
                      <video width="100%" height="240" controls>
                          <source src={"" + videoPath} type="video/mp4" />
                          <source src={"" + videoPath} type="video/ogg" />
                          Your browser does not support the video tag. Please use another browser.
                      </video>


                   </div>
               </div>
           );
      }

  }

  render() {

      return(
      <div>
        { this.props.blogimages && this.props.blogimages.length > 0 &&
              this.props.blogimages.length > 1 ? this.renderCarousel(this.props.blogimages, this.props.blog.blogId)
                                           : this.renderImage(this.props.blogimages[0], this.props.blog)

        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CarouselWidget.js